﻿let $ = require('jquery');


module.exports = Iframe;

function Iframe(customOptions) {

    $(window).on("message onmessage", function (e) {
        let height = e.originalEvent.data;
        customOptions.element.height(height + 'px');
    });
}